import { z } from "zod";

export const BillPaymentStatusSchema = z.enum([
  "PENDING",
  "APPROVED",
  "REJECTED",
  "PAID",
  "PAID_OUTSIDE",
  "PROCESSING",
  "FAILED",
  "CANCELLED",
  "RETURNED",
]);

export type BillPaymentStatus = z.infer<typeof BillPaymentStatusSchema>;
